import { Component, inject } from '@angular/core'
import { FormsModule } from '@angular/forms'
import { WjInputModule } from '@grapecity/wijmo.angular2.input'
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap'

import { Meeting } from '../../shared'

@Component({
    selector: 'app-meeting-picker-modal',
    templateUrl: './meeting-picker-modal.component.html',
    standalone: true,
    imports: [FormsModule, WjInputModule],
})
export class MeetingPickerModalComponent {
    private activeModal = inject(NgbActiveModal)

    title = 'Copy Metrics from Meeting'
    confirmText = 'Add Metrics'
    meetings: Meeting[] = []
    selectedMeetingId?: string

    confirm() {
        if (!this.selectedMeetingId) return
        this.activeModal.close(this.selectedMeetingId)
    }

    cancel() {
        this.activeModal.dismiss()
    }
}
